import { Pipe, PipeTransform } from '@angular/core';
import moment from 'moment';
import { UTC_EDP_INPUT_FORMAT, MY_FORMATS, NA } from '../constants/date.const';

@Pipe({ name: 'getDateString' })
export class GetDateString implements PipeTransform {
  transform(date: string, format = MY_FORMATS): string {
    return date ? moment(date, UTC_EDP_INPUT_FORMAT).format(format) : NA;
  }
}
